<template>
  <BQdtCard
    name="comparisonTitle"
    type="header-item"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'ComparisonHeader',

  components: { BQdtCard },
}
</script>
